import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import dolphin1 from './Asset/dolphin-1.webp';
import dolphin2 from './Asset/dolphin-2.webp';
import dolphin3 from './Asset/dolphin-3.webp';
import dolphin4 from './Asset/dolphin-4.webp';
import dolphin5 from './Asset/dolphin-5.webp';
import dolphin6 from './Asset/dolphin-6.webp';
import dolphin7 from './Asset/dolphin-7.webp';
import dolphin8 from './Asset/dolphin-8.webp';
import dolphin9 from './Asset/dolphin-9.webp';
import brochure from './Asset/DOLPHIN-BROCHURE.pdf';
import PageSeo, {
  breadcrumbJsonLd,
  keywordSets,
  productJsonLd,
} from './PageSeo';

function JelajahiDolphin() {
  const sections = useRef([]);
  const [visibleSections, setVisibleSections] = useState({});

  const images = [
    {
      src: dolphin1,
      title: 'BYD DOLPHIN',
      specs: [
        { value: '7.0s', label: '0-100 km/jam' },
        { value: '490km', label: 'Jarak (NEDC)' },
        { value: '160Km/jam', label: 'Kecepatan Penuh' },
      ],
    },
    {
      src: dolphin2,
      title: 'Tim Desainer Kelas Internasional',
      description: `Dipimpin oleh Kepala Desainer Otomotif Wolfgang Egger, tim desain kelas dunia mengintegrasikan inovasi dengan kualitas dan keandalan.`,
    },
    {
      src: dolphin3,
      title: 'Estetika Laut',
      description: `BYD DOLPHIN mengadopsi konsep desain baru 'Estetika Laut'. Garis bodi yang canggih, dipadukan dengan garis-garis tajam dan kontur yang mengalir, memproyeksikan desain yang percaya diri dan elegan yang ditopang oleh daya listrik bertenaga. Nikmati kebebasan dengan BYD DOLPHIN.`,
    },
    {
      src: dolphin4,
      title: 'Pencahayaan',
      description: `Desain lampu depan dan belakang terinspirasi oleh gerakan dinamis lumba-lumba yang melompat keluar dari lautan. Lampu depan LED yang terus-menerus melintang di gril tengah dan desain lampu belakang yang dinamis mengungkapkan nuansa gaya dan teknologi avant-garde.`,
    },
    {
      src: dolphin5,
      title: 'Konsol Tengah Mengambang',
      description: `Desain konsol tengah yang futuristik menciptakan lingkungan berkendara yang modern dan dinamis dengan detail trim logam yang melintang di seluruh dashboard, membentuk permukaan melengkung yang indah dan minimalis.`,
    },
    {
      src: dolphin6,
      title: 'Teknologi Mutakhir',
    },
    {
      src: dolphin7,
      title: 'e-Platform 3.0',
      description: `BYD DOLPHIN dilengkapi dengan platform baru BYD e-Platform 3.0 yang dirancang khusus untuk kendaraan listrik murni. Memaksimalkan keunggulan kecerdasan, efisiensi, keamanan, dan estetika, e-Platform 3.0 bertujuan untuk meningkatkan kinerja kendaraan energi baru (NEV) dalam hal keamanan dan jangkauan mengemudi pada suhu rendah serta memperbaiki pengalaman mengemudi cerdas, guna membangun kendaraan listrik cerdas baru yang lebih efisien dan aman.`,
    },
    {
      src: dolphin8,
      title: 'Teknologi Baterai Blade Paten Ultra-Aman',
      description: `Saat menjalani uji penetrasi paku, Baterai Blade tidak mengeluarkan asap maupun api setelah tertusuk, dan suhunya hanya mencapai 30 hingga 60°C. Sel-sel Baterai Blade juga lulus uji kondisi ekstrem lainnya, seperti dihancurkan, dibengkokkan, dipanaskan dalam tungku hingga 300°C, dan diisi daya berlebih hingga 260%. Tidak ada dari kondisi ini yang mengakibatkan kebakaran atau ledakan.`,
    },
    {
      src: dolphin9,
      title: 'BYD DOLPHIN',
    },
  ];

  useEffect(() => {
    const currentSections = sections.current;

    const observer = new IntersectionObserver(
      (entries) => {
        setVisibleSections((prev) => {
          const updated = { ...prev };
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updated[entry.target.dataset.index] = true;
            }
          });
          return updated;
        });
      },
      { threshold: 0.5 },
    );

    currentSections.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <Box>
      <PageSeo
        title='BYD Dolphin BSD Serpong | Harga, Spesifikasi, Promo'
        description='Jelajahi BYD Dolphin di BYD BSD Serpong. Cek harga, spesifikasi, fitur, brosur, promo, dan jadwal test drive mobil listrik hatchback BYD.'
        keywords={[
          ...keywordSets.localDealer,
          'harga BYD Dolphin BSD',
          'BYD Dolphin Tangerang',
          'spesifikasi BYD Dolphin',
          'test drive BYD Dolphin',
        ]}
        path='/jelajahi-dolphin'
        image={dolphin1}
        jsonLd={[
          productJsonLd({
            name: 'BYD Dolphin',
            description:
              'Mobil listrik hatchback BYD Dolphin dengan desain Ocean Aesthetics, Blade Battery, dan fitur modern.',
            image: dolphin1,
            path: '/jelajahi-dolphin',
            lowPrice: 369000000,
            highPrice: 429000000,
            offerCount: 2,
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'BYD Dolphin', path: '/jelajahi-dolphin' },
          ]),
        ]}
      />
      <Typography
        variant='h1'
        component='h1'
        sx={{
          fontSize: { xs: '2rem', sm: '3rem' },
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: 4,
          marginTop: 2,
        }}
      >
        Jelajahi BYD Dolphin
      </Typography>
      {images.map((img, index) => (
        <Box
          key={index}
          ref={(el) => (sections.current[index] = el)}
          data-index={index}
          sx={{
            position: 'relative',
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            component='img'
            src={img.src}
            alt={`Image ${index + 1}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
          />

          {img.title && (
            <Box
              sx={{
                position: 'absolute',
                top: { xs: '10%', sm: '15%' },
                color:
                  img.src === dolphin2 || img.src === dolphin6
                    ? '#000'
                    : '#fff', // Black for atto4 and atto7
                textAlign: 'center',
                padding: 2,
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='h4'
                fontWeight='bold'
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}
              >
                {img.title}
              </Typography>
            </Box>
          )}

          {img.specs && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '10%', sm: '5%' },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                gap: { xs: 2, sm: 4 },
                color: '#fff',
              }}
            >
              {img.specs.map((spec, i) => (
                <React.Fragment key={i}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                      }}
                    >
                      {spec.value}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                      }}
                    >
                      {spec.label}
                    </Typography>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          )}

          {img.description && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '15%', sm: '10%' },
                color: '#fff',
                textAlign: 'center',
                padding: 2,
                maxWidth: { xs: '90%', sm: '80%' },
                background: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='body1'
                fontWeight='400'
                lineHeight='1.5'
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                {img.description}
              </Typography>
            </Box>
          )}

          {img.src === dolphin9 && (
            <Button
              href={brochure}
              download='DOLPHIN-BROCHURE.pdf'
              variant='outlined'
              sx={{
                position: 'absolute',
                bottom: '10%',
                borderColor: '#fff',
                color: '#fff',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                fontWeight: 600,
                padding: { xs: '8px 16px', sm: '10px 20px' },
                '&:hover': {
                  backgroundColor: '#fff',
                  color: '#000',
                },
              }}
            >
              Download Brosur
            </Button>
          )}
        </Box>
      ))}
      <Box
        sx={{
          padding: { xs: 3, sm: 6 },
          backgroundColor: '#f5f5f5',
          textAlign: 'center',
        }}
      >
        <Typography
          variant='h2'
          sx={{
            fontSize: { xs: '1.5rem', sm: '2rem' },
            fontWeight: 600,
            mb: 2,
          }}
        >
          Tertarik dengan BYD Dolphin? 🐬
        </Typography>
        <Typography variant='body1' sx={{ mb: 3 }}>
          Dapatkan info lengkap dan promo terbaru{' '}
          <strong>Harga BYD Dolphin</strong> hanya di{' '}
          <strong>BYD BSD Serpong</strong>. Kami juga menyediakan informasi
          lengkap tentang <strong>Harga Danza D9</strong>,{' '}
          <strong>Harga Sealion 7</strong>, dan <strong>Harga Atto1</strong>{' '}
          langsung dari dealer resmi.
        </Typography>
        <Button
          href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20BYD%20Dolphin%20dan%20ingin%20tahu%20harganya'
          target='_blank'
          variant='contained'
          color='primary'
        >
          Tanya Harga Sekarang
        </Button>
      </Box>
    </Box>
  );
}

export default JelajahiDolphin;
